<script setup>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel";
import { toRefs, computed } from "vue";

const props = defineProps({
  productsData: Array,
});

const { productsData } = toRefs(props);

// orderフィールドでソートするヘルパー関数
const sortByOrder = (a, b) => {
  const orderA =
    a.order !== undefined && a.order !== null && a.order !== "" ? Number(a.order) : 9999;
  const orderB =
    b.order !== undefined && b.order !== null && b.order !== "" ? Number(b.order) : 9999;
  const numA = isNaN(orderA) ? 9999 : orderA;
  const numB = isNaN(orderB) ? 9999 : orderB;
  return numA - numB;
};

// 開催中（現在開催中）
const onAirData = computed(() => {
  return productsData.value
    .filter((p) => {
      if (!p.eventdate || !p.eventdate.start || !p.eventdate.end) return false;
      const now = Date.now();
      return p.eventdate.start.toDate() < now && now < p.eventdate.end.toDate();
    })
    .sort(sortByOrder);
});

// 開催予定（まだ開始していない）
const scheduledData = computed(() => {
  return productsData.value
    .filter((p) => {
      if (!p.eventdate || !p.eventdate.start) return false;
      return Date.now() < p.eventdate.start.toDate();
    })
    .sort(sortByOrder);
});

// 開催終了
const endedData = computed(() => {
  return productsData.value
    .filter((p) => {
      if (!p.eventdate || !p.eventdate.end) return false;
      return p.eventdate.end.toDate() < Date.now();
    })
    .sort(sortByOrder);
});

// 表示順：開催中 → 開催予定 → 開催終了
const sortedCarouselData = computed(() => {
  return [...onAirData.value, ...scheduledData.value, ...endedData.value];
});

const onSlideChange = () => {
  console.log("Slide changed");
};
</script>

<template>
  <carousel
    :items-to-show="1"
    wrap-around
    autoplay="5000"
    pauseAutoplayOnHover="true"
    @change="onSlideChange"
  >
    <Slide v-for="(slide, index) in sortedCarouselData" :key="index">
      <div class="carousel__item">
        <img class="sliderPhoto" v-bind:src="slide.vendor_image" />
      </div>
    </Slide>

    <template #addons>
      <navigation />
      <pagination />
    </template>
  </carousel>
</template>

<style scoped>
.sliderPhoto {
  width: 100%;
}
</style>
